<template>
  <!-- Header Section -->
  <div class="row wrapper border-bottom white-bg page-heading">
    <!-- Title on the left -->
    <div class="col-lg-8 align-self-center">
      <h2 class="mb-0">
        {{ $t("navigations.epro management dashboard") }} -
        <small>
          {{
            $t("navigations.real-time patient reported outcomes monitoring")
          }}</small
        >
      </h2>
    </div>
    <div class="text-end col-lg-4 align-self-center"></div>
  </div>

  <!-- Summary Cards -->
  <div class="wrapper wrapper-content">
    <div class="row mb-2">
      <div class="col-md-3 px-1">
        <div class="card h-100 border-start border-2 border-primary">
          <div
            class="card-body"
            @click="openEproPopupSubjects"
            style="cursor: pointer"
          >
            <div class="d-flex align-items-center">
              <div class="bg-primary bg-opacity-10 p-3 rounded me-3">
                <i class="fa fa-users text-white fs-4"></i>
              </div>
              <div>
                <h5 class="card-title"> {{ $t("navigations.active subjects") }}</h5>
                <p v-if="summary.totalpatients" class="card-text fs-4 mb-0">
                  {{ summary.totalpatients }}
                </p>
                <p class="card-text fs-4 mb-0" v-else>0</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3 px-1">
        <div class="card h-100 border-start border-2 border-success">
          <div
            class="card-body"
            @click="openEproPopupCompliance"
            style="cursor: pointer"
          >
            <div class="d-flex align-items-center">
              <div class="bg-success bg-opacity-10 p-3 rounded me-3">
                <i class="fa fa-clipboard text-white fs-4"></i>
              </div>
              <div>
                <h5 class="card-title">
                  {{ $t("navigations.data compliance") }}
                </h5>
                <p class="card-text fs-4 mb-0" v-if="summary.compliance">
                  {{ summary.compliance }}%
                </p>
                <p
                  class="card-text fs-4 mb-0"
                  v-else
                  @click="openEproPopupCompliance"
                >
                  0
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3 px-1">
        <div class="card h-100 border-start border-2 border-warning">
          <div
            class="card-body"
            @click="openEproPopupAlert"
            style="cursor: pointer"
          >
            <div class="d-flex align-items-center">
              <div class="bg-warning bg-opacity-10 p-3 rounded me-3">
                <i class="fa fa-exclamation-triangle text-white fs-4"></i>
              </div>
              <div>
                <h5 class="card-title">{{ $t("navigations.alerts") }}</h5>
                <p class="card-text fs-4 mb-0" v-if="summary.alerts">
                  {{ summary.alerts }}
                </p>
                <p
                  class="card-text fs-4 mb-0"
                  v-else
                  @click="openEproPopupAlert"
                  style="cursor: pointer"
                >
                  0
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3 px-1">
        <div class="card h-100 border-start border-2 border-info">
          <div
            class="card-body"
            @click="openEproPopupCompletedForms"
            style="cursor: pointer"
          >
            <div class="d-flex align-items-center">
              <div class="bg-info bg-opacity-10 p-3 rounded me-3">
                <i class="fa fa-check-square-o text-white fs-4"></i>
              </div>
              <div>
                <h5 class="card-title">
                  {{ $t("navigations.completed forms") }}
                </h5>
                <p class="card-text fs-4 mb-0" v-if="summary.completed">
                  {{ summary.completed }}
                </p>
                <p
                  class="card-text fs-4 mb-0"
                  v-else
                  @click="openEproPopupCompletedForms"
                  style="cursor: pointer"
                >
                  0
                </p>
                <!-- <p class="card-text fs-4 mb-0" v-else>0</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="row">
      <!-- Patient List -->
      <div class="col-12 col-md-6 px-1">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5 class="mb-0">{{ $t("navigations.subject enrolment") }}</h5>
            <div class="ibox-tools"></div>
          </div>
          <div class="ibox-content tableminheight">
            <div class="text-center" v-if="showLoading === true">
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class=""
                alt="Waiting for login"
              />
            <div>
              {{ $t("navigations.please wait while the list is being loaded") }}
            </div>
          </div>      
          <template  v-else>
            <div class="text-center" v-if="patientlist.length==0">
              {{ $t('navigations.no data available') }}
            </div>
            <div v-else class="table-responsive">
              <div class="table-responsive custom-table-wrapper">
                <table class="table table-hover mb-0">
                  <thead class="table-light">
                    <tr>
                      <th class="text-wrap" style="max-width: 70px"> {{ $t("navigations.site code") }}</th>
                      <th class="text-wrap" style="max-width: 70px">
                        {{ $t("navigations.subject id") }}
                      </th>
                      <th class="text-wrap" style="max-width: 70px"> {{ $t("navigations.status") }}</th>
                      <th class="text-wrap" style="max-width: 70px">
                        {{ $t("navigations.last updated") }} 
                      </th>
                      <th class="text-center"> {{ $t("navigations.assign") }}</th>
                      <th class="text-center"> {{ $t("navigations.activity") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="patient in patientlist"
                      :key="patient.patientId"
                      class="cursor-pointer"
                    >
                      <td class="text-wrap" style="max-width: 70px">
                        <i class="fa fa-person-circle me-2"></i>
                        {{ patient.siteCode }}
                      </td>
                      <td class="text-wrap" style="max-width: 70px">
                        <i class="fa fa-person-circle me-2"></i>
                        {{ patient.subjectId }}
                      </td>
                      <td>
                        <span :class="`badge bg-${status[patient.status]}`">
                          {{ patient.status }}
                        </span>
                      </td>
                      <td class="text-wrap" style="max-width: 70px">
                        {{ filter(patient.lastFormLastModifiedAt) }}
                        {{ toTime(patient.lastFormLastModifiedAt) }}
                      </td>
                      <td class="text-center">
                        <button
                          class="border-0 bg-transparent py-0 px-2"
                          type="button"
                          @click="openEproFormPopup(patient.patientId)"
                        >
                          <i class="fa fa-external-link-square edit-delete"></i>
                          <!-- <i class="fa fa-plus"></i> Add -->
                        </button>
                      </td>
                      <td class="text-center">
                        <button
                          class="border-0 bg-transparent py-0 px-2"
                          type="button"
                          @click="openEproAcitivtyPopup(patient.patientId)"
                        >
                          <i class="fa fa-clock-o edit-delete"></i>
                          <!-- <i class="fa fa-plus"></i> Add -->
                        </button>
                      </td>
                      <!-- <td>
                        <div class="d-flex align-items-center">
                          <div class="progress flex-grow-1 me-2" style="height: 6px;">
                            <div class="progress-bar bg-success" 
                                :style="`width: ${patient.compliance}%`"></div>
                          </div>
                          <small>{{ patient.compliance }}%</small>
                        </div>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
          </div>
        </div>
      </div>

      <!-- Recent Submissions -->
      <div class="col-12 col-md-6 px-1">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5 class="mb-0">
              {{ $t("navigations.recent form submissions") }}
            </h5>
          </div>
        <div class="ibox-content tableminheight">
          <div class="text-center" v-if="showRecentSubLoading === true">
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class=""
                alt="Waiting for login"
              />
            <div>
              {{ $t("navigations.please wait while the list is being loaded") }}
            </div>
          </div>      
          <template  v-else>

              <div class="text-center" v-if="recentsubmissions.length==0">
                {{ $t('navigations.no data available') }}
              </div>           
              <div v-else class="table-responsive custom-table-wrapper">
                <table class="table table-hover mb-0">
                  <thead class="table-light">
                    <tr>
                      <th class="text-wrap" style="max-width: 70px">{{ $t("navigations.site code") }}</th>
                      <th class="text-wrap" style="max-width: 70px">
                      {{ $t("navigations.subject id") }} 
                      </th>
                      <th class="text-wrap" style="max-width: 70px">{{ $t("navigations.visit no") }}</th>
                      <th class="text-wrap" style="width: 100px">{{ $t("navigations.form name") }}</th>
                      <th class="text-wrap" style="max-width: 70px">
                        {{ $t("navigations.data source") }}
                      </th>
                      <th class="text-wrap" style="max-width: 70px">
                        {{ $t("navigations.form status") }}
                      </th>
                      <th class="text-center align-middle">{{ $t("navigations.view") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="sub in recentsubmissions" :key="sub.id">
                      <td class="text-wrap" style="max-width: 70px">
                        {{ sub.siteCode }}
                      </td>
                      <td class="text-wrap" style="max-width: 70px">
                        {{ sub.subjectCode }}
                      </td>
                      <td class="text-wrap" style="max-width: 70px">
                        {{ sub.visitNo }}
                      </td>
                      <td class="text-wrap" style="width: 100px">
                        {{ sub.formName }}
                      </td>
                      <td
                        class="text-wrap"
                        style="max-width: 70px"
                        :title="sub.sourceID"
                      >
                        {{ sub.dataSource }}
                      </td>
                      <td>
                        <span :class="`badge bg-${formstatus[sub.formStatus]}`">
                          <i :class="`fa fa-${sub.icon} me-1`"></i
                          >{{ sub.formStatus }}
                        </span>
                      </td>
                      <td class="text-center align-middle">
                        <a @click.prevent="gotoform(sub.id)">
                          <i class="fa fa-eye editicon"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            
          </template>
          </div>
        </div>
      </div>

      <!-- Questionnaire Management -->
      <div class="col-12 col-md-6 px-1">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5 class="mb-0">{{ $t("navigations.ePRO form list") }}</h5>
          </div>
           <div class="ibox-content tableminheight">
            <div class="text-center" v-if="showEcrfLoading === true">
                <img
                  src="../../assets/img/loading.gif"
                  width="15"
                  class=""
                  alt="Waiting for login"
                />
              <div>
                {{ $t("navigations.please wait while the list is being loaded") }}
              </div>
            </div>      
            <template  v-else>           
                <div class="text-center" v-if="ecrfformlist.length==0">
                  {{ $t('navigations.no data available') }}
                </div>
            
                <div  v-else  class="table-responsive custom-table-wrapper">
                  <table class="table table-hover mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>{{ $t("navigations.form name") }}</th>
                        <th>{{ $t("navigations.version") }}</th>
                        <th>{{ $t("navigations.view") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="ecrfforms in ecrfformlist"
                        :key="ecrfforms.template_ID"
                      >
                        <td>{{ ecrfforms.templateName }}</td>
                        <td>{{ ecrfforms.version }}</td>
                        <td>
                          <a @click.prevent="showformmodel(ecrfforms.template_ID)">
                            <i class="fa fa-eye editicon"></i
                          ></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              
            </template>
          </div>
        </div>
      </div>
      <viewAlertDetailsPopup
        v-if="showAlertDetailsPopup"
        ref="viewPopup"
        :AlertId="alertId"
        :AlertType="alertType"
         @openQueryPopup="Openquerypopup(alertId)"
        @callViewModal="openAlertStatusPopup($event)"
        @closeModal="closeAlertDetailsPopup"
      />
      <AlertStatusPopup
        v-if="showAlertStatusPopup"
        :Id="alertId"
        @closemodal="closeAlertStatusPopup"
      />
      <!-- Data Visualization -->
      <div class="col-12 col-md-6 px-1">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5 class="mb-0">{{ $t("navigations.active alerts") }}</h5>
            <div class="ibox-tools">
              <button class="btn btn-sm btn-outline-secondary me-1 py-0">
                <i class="fa fa-download"></i>
              </button>
              <button class="btn btn-sm btn-outline-secondary py-0">
                <i class="fa fa-filter"></i> Filters
              </button>
            </div>
          </div>
          <div class="ibox-content tableminheight">
          <div class="text-center" v-if="showActiveLoading === true">
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class=""
                alt="Waiting for login"
              />
            <div>
              {{ $t("navigations.please wait while the list is being loaded") }}
            </div>
          </div>      
          <template  v-else>
            <div class="text-center" v-if="activeAlerts.length==0">
              {{ $t('navigations.no data available') }}
            </div>
            <div class="table-responsive custom-table-wrapper" v-else>
              <table class="table table-hover mb-0 flex-grow-1 cursor-pointer">
                <thead class="table-light">
                  <tr>
                    <th>{{ $t("navigations.subject id") }}</th>
                    <th>{{ $t("navigations.type") }}</th>
                    <th>{{ $t("navigations.time elapsed") }}</th>
                    <!-- <th>Status</th> -->
                    <!-- <th>Actions</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="alert in activeAlerts"
                    :key="alert.id"
                    class="alert-row"
                  >
                    <td>
                      <div
                        class="d-flex align-items-center"
                        @click="viewAlertDetails(alert.id, 'active alerts')"
                      >
                        {{ alert.subjectCode }}
                      </div>
                    </td>
                    <td>
                      <span
                        class="alert-type-badge"
                        :class="{
                          'alert-primary':
                            alert.alertConfig.Priority == 'Major',
                          'alert-primary': alert.alertConfig.Priority == 'High',
                          'alert-info':
                            alert.alertConfig.Priority == 'Moderate',
                          'alert-danger':
                            alert.alertConfig.Priority == 'Critical',
                        }"
                        @click="viewAlertDetails(alert.id, 'active alerts')"
                        >{{ alert.alertConfig.AlertType }}</span
                      >
                    </td>
                    <!-- <td :class="alert.status === 'Pending' ? 'time-elapsed' : ''">
                      {{ alert.status === 'Pending' ? alert.timeElapsed + ' min' : 'Resolved' }}
                    </td> -->
                    <td @click="viewAlertDetails(alert.id, 'active alerts')">
                      {{ relativeTime(alert.createdAt) }}
                    </td>
                    <!-- <td>
                      <span :class="['alert-badge', alert.status === 'Pending' ? 'badge-pending' : 'badge-resolved']">
                        {{ alert.status }}
                      </span>
                    </td> -->
                    <!-- <td>
                      <button class="btn btn-sm btn-success mr-1 py-0 w-100" @click="resolveAlert(alert.id)"
                        :disabled="alert.status === 'Resolved'">
                        <small>{{ alert.status === 'Pending' ? 'Resolve' : 'Resolved' }}</small>
                      </button>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Assign form popup starts -->
  <AssignEproPopup
    v-if="showAddEproFormTemplate"
    :subjectId="patientId"
    :visitName="''"
    @closemodal="closeEproModal(patientId)"
  />
  <!-- Assign popup ends -->

  <customModal
    v-if="showAddEproActivityTemplate == true"
    :containerxl="true"
    @closeModal="closeEproActivitytModal(patientId)"
  >
    <template #title>
      {{ $t("navigations.activity") }}
    </template>
    <template #body>
      <div class="text-center" v-if="loadingSchedules == true">
        <p class="mb-0">
          {{ $t("navigations.please wait while the list is being loaded") }}
        </p>
        <img
          src="../../assets/img/loading.gif"
          width="15"
          alt="Waiting for login"
        />
      </div>
      <div v-else>
        <div v-if="scheduleList.length == 0">
          <h4 class="text-center">{{ $t("navigations.no data available") }}</h4>
        </div>
        <div v-else>
          <!-- <div class="d-flex justify-content-between pb-3 border-bottom">
                <div class="search-container">
                    <input type="text" class="form-control form-control-sm" placeholder="Search forms..." style="width: 200px;">
                </div>
                
                <select class="form-select form-select-sm" style="width: 140px;">
                    <option>All Statuses</option>
                    <option selected>Completed</option>
                    <option>Pending</option>
                    <option>Overdue</option>
                </select>
                
                <select class="form-select form-select-sm" style="width: 160px;">
                    <option>All Forms</option>
                    <option>Adverse Events</option>
                    <option>Symptom Diary</option>
                    <option>Quality of Life</option>
                    <option>Treatment Satisfaction</option>
                    <option>Sleep Logs</option>
                </select>
                 <div class="d-flex align-items-center gap-1">
                        <span class="date-label">From:</span>
                        <input type="date" class="form-control form-control-sm" value="2025-06-01" style="width: 120px;">
                    </div>
                    <div class="d-flex align-items-center gap-1">
                        <span class="date-label">To:</span>
                        <input type="date" class="form-control form-control-sm" value="2025-06-30" style="width: 120px;">
            </div>
            </div>                 -->

          <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th style="width: 35%">
                    {{ $t("navigations.epro form name") }}
                  </th>
                  <th style="width: 15%">{{ $t("navigations.status") }}</th>
                  <th style="width: 20%">
                    {{ $t("navigations.data source") }}
                  </th>
                  <th style="width: 15%">
                    {{ $t("navigations.expected date") }}
                  </th>
                  <th style="width: 15%">
                    {{ $t("navigations.completion date") }}
                  </th>
                  <th class="text-center" style="width: 15%">
                    {{ $t("navigations.view") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="schedule in scheduleList" :key="schedule.patientId">
                  <td>
                    <div class="form-name">
                      <span>{{ schedule.templateName }}</span>
                    </div>
                  </td>
                  <td>
                    <span
                      class="badge"
                      :style="{
                        backgroundColor: schedule.formStatusHex,
                        color: '#333',
                      }"
                      >{{ schedule.formStatus }}</span
                    >
                  </td>
                  <td>
                    <div class="form-name" :title="schedule.dataSourceId">
                      <span  v-if="schedule.formStatus == 'Completed'">{{
                        schedule.dataSource ? schedule.dataSource : ""
                      }}</span>
                    </div>
                  </td>
                  <td>
                    <span>{{ filter(schedule.visitDate) }}</span>
                  </td>
                  <td>
                    <div class="date-cell">
                      <div class="date-value">
                        {{ filter(schedule.visitCompletedDate) }}
                      </div>
                      <div class="completion-time">
                        {{ toTime(schedule.visitCompletedDate) }}
                      </div>
                    </div>
                  </td>
                  <td class="text-center">
                    <a
                      v-if="schedule.formStatus == 'Completed'"
                      @click.prevent="gotoform(schedule.formId)"
                    >
                      <i class="fa fa-eye editicon"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
    <!--  <template #body>
      <div class="text-center" v-if="loadingSchedules==true">
        <p class="mb-0">{{$t("navigations.please wait while the list is being loaded")}}</p>
        <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
      </div>
      <div v-else>
        <div v-if="scheduleList.length==0">
          <h4 class="text-center">{{$t('navigations.no data available')}}</h4>
        </div>
           <table v-else class="table features-table">
        <thead>
          <tr>
            <th>{{ $t('navigations.epro form name') }}</th>
            <th>{{ $t('navigations.status') }}</th>
            <th>{{ $t('navigations.expected date') }}</th>
            <th>{{ $t('navigations.completion date') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="schedule in scheduleList" :key="schedule.patientId">
            <td>{{ schedule.templateName }}</td>
            <td>
              <span :class="returnClass(schedule.formStatus)">{{ schedule.formStatus }}</span>
            </td>
            <td><small>
                <span>{{ filter(schedule.visitDate) }}</span></small>
            </td>
            <td><small>
              <span>{{ filter(schedule.visitCompletedDate) }} {{  toTime(schedule.visitCompletedDate) }}</span></small>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
   
    </template> -->
  </customModal>
  <customModal
    v-if="showpop == true"
    :containersm="true"
    :footerShow="true"
    @closeModal="CloseComplianceList"
  >
    <template #title>
      {{ $t("navigations.data compliance") }}
    </template>
    <template #body>
      <!-- <label class="col-form-label">Data Compliance</label> -->
      <div class="table-responsive mt-2 scrollable">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>{{ $t("navigations.subject id") }}</th>
              <th>{{ $t("navigations.compliance") }}(%)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in Compliance" :key="item.patientNo">
              <td>{{ item.patientNo }}</td>
              <td>
                {{ item.compliancePercentage ? item.compliancePercentage : 0 }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer> </template>
  </customModal>

  <customModal
    v-if="showpoup == true"
    :containersm="true"
    :footerShow="true"
    @closeModal="CloseAlertList"
  >
    <template #title>
      {{ $t("navigations.alerts") }}
    </template>
    <template #body>
      <div class="table-responsive mt-2 scrollable">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>Subject ID</th>
              <th>Type</th>
              <th>Status</th>
              <th>Received Date</th>
            </tr>
          </thead>
          <tbody>
           
            
            <tr  v-for="item in activeAlerts" :key="item.id">
              <td>{{ item.subjectCode }}</td>
              <td>{{ item.alertConfig?.AlertType }}</td>
              <td>{{ item.status }}</td>
              <td>
                {{ filter(item.createdAt) }}
                {{ toTime(item.createdAt) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer>
    </template>
  </customModal>

  <customModal
    v-if="showpopup == true"
    :containersm="true"
    :footerShow="true"
    @closeModal="CloseCompletedFormtList"
  >
    <template #title>
      {{ $t("navigations.completed forms") }}
    </template>
    <template #body>
      <!-- <label class="col-form-label">Form List</label> -->
      <div class="table-responsive mt-2 scrollable">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>{{ $t("navigations.site code") }}</th>
              <th>{{ $t("navigations.subject id") }}</th>
              <th>{{ $t("navigations.form name") }}</th>
              <th>{{ $t("navigations.view") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in completedarray" :key="item.subjectId">
              <td>{{ item.siteId }}</td>
              <td>{{ item.subjectId }}</td>
              <td>
                <div v-if="Array.isArray(item.formsName)">
                  <div
                    v-for="(form, idx) in item.formsName"
                    :key="idx"
                    class="d-flex align-items-center mb-1"
                  >
                    <span>{{ form }}</span>
                  </div>
                </div>
                <div v-else>
                  <span>{{ item.formsName }}</span>
                </div>
              </td>
              <td>
                <div
                  v-if="
                    Array.isArray(item.formsName) && Array.isArray(item.formIds)
                  "
                >
                  <div
                    v-for="(form, idx) in item.formsName"
                    :key="idx"
                    class="mb-1"
                  >
                    <a
                      v-if="item.formIds[idx]"
                      @click.prevent="
                        gotoform(item.formIds[idx], item.formStatus, form)
                      "
                    >
                      <i class="fa fa-eye editicon"></i>
                    </a>
                  </div>
                </div>
                <div v-else>
                  <a
                    v-if="Array.isArray(item.formIds) && item.formIds[0]"
                    @click.prevent="
                      gotoform(item.formIds[0], item.formStatus, item.formsName)
                    "
                  >
                    <i class="fa fa-eye editicon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer> </template>
  </customModal>
  <customModal
    v-if="showpopups == true"
    :containersm="true"
    :footerShow="true"
    @closeModal="CloseSubjectList"
  >
    <template #title> {{ $t("navigations.active subject list") }} </template>
    <template #body>
      <!-- <label class="col-form-label">Active Subjects</label> -->
      <div class="table-responsive mt-2 scrollable">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>{{ $t("navigations.site code") }}</th>
              <th>{{ $t("navigations.subject id") }}</th>
              <th>{{ $t("navigations.status") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in patientlist" :key="item.patientId">
              <td>{{ item.siteCode }}</td>
              <td>{{ item.subjectId }}</td>
              <td>{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer> </template>
  </customModal>
  
  <customModal
    v-if="querypopup == true"
    ref="listPopupRef"
    :containermd="true"
    :bodymd="
      subjectActivityList && subjectActivityList.length > 10 ? true : false
    "
    @queryAlertCount="querycount()"
    @closeModal="Closequerypopup()"
    
  >
    <template #title>
      Queries
    </template>
    <template #body>
      <div class="text-center">
        <div v-if="!showContent">
          <div class="text-center">
            <h4>{{ $t("navigations.no queries found") }}</h4>
          </div>
        </div>
        <div v-if="showloader" class="spinner-overlay">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
        <div v-else-if="showContent" class="table-responsive scrollable" > 
          <table class="tableFixHead table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th>{{ $t("navigations.query id") }}</th>
                <th>{{ $t("navigations.query subject") }}</th>
                <th>{{ $t("navigations.query status") }}</th>
                <th>{{ $t("navigations.field name") }}</th>
                <th>{{ $t("navigations.view") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="query in Querydetails" :key="query.id">
                <td>{{ query.queryId }}</td>
                <td>{{ query.query_Subject }}</td>
                <td>{{ query.queryOpenStatus }}</td>
                <td>{{ query.fieldName }}</td>
                <td class="tdtext">
                  <a href="#" class="editicon"><i class="fa fa-eye" @click.prevent="viewforms(query.id)"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- test -->
      </div>
      
    </template>
  </customModal>
   <viewAlertQueryPopup
    v-if="showQueryAlertPopup"
    :queryid="queryid"
    @closeQuery="showQueryAlertPopup=false"
    :closedoption="closedoption"
    @applychanges="applychanges($event)"
  />
  <showformmodel
    v-if="setshowFormModal"
    :formid="currentform"
    :currentformstatus="currentformstatus"
    @closeformModal="closeformModal()"
  />
</template>
<script src="./epro.js"></script>
<style scoped>
.alert-type-badge {
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 0.7rem;
}

.header {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.card {
  border: none;
  border-radius: 0px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
}

.card:hover {
  transform: translateY(-5px);
}

.badge {
  font-weight: 500;
  padding: 0.5em 0.8em;
}
.adjustheight {
  max-height: 200px;
  /* overflow: auto; */
}

.progress {
  background-color: #e9ecef;
}

.cursor-pointer {
  cursor: pointer;
}

.alert {
  border-left: 4px solid;
  margin-bottom: 4px !important;
}
.ibox-content {
  border-radius: 0%;
}
.table-container {
  max-height: 300px;
  overflow: auto;
  position: relative;
}
/*activity modal*/
.search-container {
  position: relative;
}
.search-container i {
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}
.search-container input {
  padding-left: 36px;
}
.modal-content {
  overflow: auto;
  flex-grow: 1;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th {
  background: #f8fafc;
  color: #64748b;
  font-weight: 600;
  font-size: 12px;
  text-align: left;
  padding: 4px 4px;
  position: sticky !important;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid #e2e8f0;
}

.data-table td {
  padding: 4px 4px;
  font-size: 12px;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}

.data-table tr:hover td {
  background: #f8fafc;
}

.form-name {
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .modal-filters {
    flex-direction: column;
  }

  .search-box {
    max-width: 100%;
  }

  .data-table th,
  .data-table td {
    padding: 10px 12px;
  }

  .form-name span {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.badgeappearance {
  font-size: smaller;
  border-radius: 5px;
}
.custom-table-wrapper {
  max-height: 250px;
  overflow-x: auto;
  overflow-y: auto;
}
.tableminheight {
  min-height: 290px;
}
.custom-table-wrapper thead th {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
  font-weight: bold;
  white-space: normal;
  word-break: break-word;
}
.custom-table-wrapper table {
  table-layout: fixed;
  min-width: 100%;
  width: auto !important;
}
.scrollable {
  overflow-y: scroll;
  height: 350px;
  background-color: #ffffff;
}
</style>